import { Theme, css } from '@emotion/react';

export const slideContainer = (currentSearchLocal: string, duration: number) => css`
  display: flex;
  overflow: hidden;
  > div {
    flex: 1 0 100%;
    min-width: 100%;
    transform: translateX(${currentSearchLocal ? '-100%' : '0'});
    transition:
      transform ${duration}ms cubic-bezier(0.4, 0, 0.2, 1),
      opacity 525ms ease-in-out;
  }
`;

export const structuredSearchContainer = (
  currentSearchLocal: string,
  isStructuredSearchVisible: boolean
) => css`
  opacity: ${currentSearchLocal ? 0 : 1};
  visibility: ${isStructuredSearchVisible ? 'visible' : 'hidden'};
  [data-testid='location-text-field'] {
    display: none;
  }
`;

export const omniSearchContainer = (
  currentSearchLocal: string,
  isOmnisearchVisible: boolean,
  { colors }: Theme
) => css`
  background-color: ${colors.bgDefault};
  max-height: ${currentSearchLocal === '' ? 0 : 'none'};
  visibility: ${isOmnisearchVisible ? 'visible' : 'hidden'};
  opacity: ${currentSearchLocal ? 1 : 0};
`;
